/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../app/modules/auth'
import { PageTitle } from '../../../_metronic/layout/core'
import { XYGraphWidget, PieChartGraphWidget } from '../../../_metronic/partials/widgets';
import { getAsync } from '../../../_metronic/helpers/httpClient'
import { Row, Col, Card, CardTitle, CardHeader, CardBody } from 'reactstrap';
import PolicyChecker from '../../../_metronic/helpers/components/PolicyChecker'
import { enumPolicies } from '../../../_metronic/helpers'

import CalendarComponent from '../../../app/modules/CalendarComponent';
// @ts-ignore
import DashboardProductions from './DashboardProductions';
// @ts-ignore
import AluminiumStockCard from '../stock-management/stock/AluminiumStockCard';
// @ts-ignore
import OrderStatisticsCard from './OrderStatisticsCard';

const DashboardWrapper: FC = () => {
  const intl = useIntl()

  const { currentUser } = useAuth();
  const [leadsMetric, setLeadMetric] = useState<any>('');
  const [newLeadDataItems, setItems] = useState([])
  const [ordersMetric, setOrdersMetric] = useState<any>('');
  const [loadingOrders, setLoadingOrders] = useState(false);

  useEffect(() => {
    const leadsMetric = async () => {
      const response = await getAsync("/dashboards/leads-metrics")
      if (response && response.data) {
        setLeadMetric(response.data)
        setItems(response.data.newLeadsCountPerCampaign)
      }
    }

    const ordersMetric = async () => {
      setLoadingOrders(true);
      const response = await getAsync("/dashboards/orders-metrics")
      if (response && response.data) {
        setOrdersMetric(response.data)
      }
      setLoadingOrders(false);
    }

    if (currentUser && currentUser.policyIds && currentUser.policyIds.some(policy => policy === enumPolicies.AdsLeadEdit)) {
      leadsMetric();
    }
    ordersMetric();
  }, [])

  const MetricCard = ({ title, subtitle, value, color }) => (
    <Card className="h-100 shadow-sm">
      <CardBody>
        <CardTitle tag="h5" className="text-muted">{title}</CardTitle>
        <p className="text-muted small">{subtitle}</p>
        <h3 className="mt-3" style={{ color }}>{value}</h3>
      </CardBody>
    </Card>
  );

  const renderLeadsMetric = () => {
    const hasLeads = (newLeadDataItems && newLeadDataItems.length > 0) || 
                     (leadsMetric && leadsMetric.dateBasedCampaigns && leadsMetric.dateBasedCampaigns.length > 0) ||
                     (leadsMetric && leadsMetric.statusBasedCampaigns && leadsMetric.statusBasedCampaigns.length > 0);

    if (!hasLeads) return null;

    return (
      <Card>
        <CardHeader>
          <CardTitle>
            {intl.formatMessage({ id: 'LEADS.METRICS.HEADER' })}
          </CardTitle>
        </CardHeader>
        <CardBody>
          <Row className="mb-4">
            {newLeadDataItems && newLeadDataItems.map(function (item) {
              return (
                <Col md={3}>
                  <MetricCard
                    title={item['title']}
                    subtitle={item['subtitle']}
                    value={item['count']}
                    color="#4CAF50"
                  />
                </Col>
              );
            })}
          </Row>
          <Row>
            <Col md={6}>
              {
                leadsMetric && leadsMetric?.dateBasedCampaigns?.length > 0 && <XYGraphWidget name={intl.formatMessage({ id: 'LEADS.METRIC.DATEBASED_CAMPAIGNTYPES' })} chartData={leadsMetric.dateBasedCampaigns} />
              }
            </Col>
            <Col md={6}>
              {
                leadsMetric && leadsMetric?.statusBasedCampaigns?.length > 0 && <XYGraphWidget name={intl.formatMessage({ id: 'LEADS.METRIC.STATUSBASED_CAMPAIGNTYPES' })} chartData={leadsMetric.statusBasedCampaigns} />
              }
            </Col>
          </Row>
        </CardBody>
      </Card>

    )
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>


      <PolicyChecker policies={[enumPolicies.ManufacturedProductRead]}>
        <DashboardProductions />
        <Row className='mb-10'></Row>
      </PolicyChecker>

      <PolicyChecker policies={[enumPolicies.AluminiumStockRead]}>
        <AluminiumStockCard />
        <Row className='mb-10'></Row>
      </PolicyChecker>

      {/* <PolicyChecker policies={[enumPolicies.CalendarEventRead]}>
        <Card>
          <CardHeader>
            <CardTitle>
              {intl.formatMessage({ id: 'CALENDAR.DASHBOARD.HEADER' })}
            </CardTitle>
          </CardHeader>
          <CardBody>
            <CalendarComponent />
          </CardBody>
        </Card>
        <Row className='mb-10'></Row>
      </PolicyChecker> */}

      <PolicyChecker policies={[enumPolicies.OrderRead, enumPolicies.OrderEdit, enumPolicies.OrderWrite]}>
        <OrderStatisticsCard ordersMetric={ordersMetric} loading={loadingOrders} />
        <Row className='mb-10'></Row>
      </PolicyChecker>

      <PolicyChecker policies={[enumPolicies.AdsLeadEdit]}>
        {renderLeadsMetric()}
        <Row className='mb-10'></Row>
      </PolicyChecker>
    </>
  )
}

export { DashboardWrapper }
